import VisibleLoading from '@/components/utilities/VisibleLoading';

const Line = ({ spaceSize, mobileOnly, width, lineVariant: variant }) => {
  const spaceClassName = spaceSize === 'lg' ? 'my-10 xl:my-20' : spaceSize === 'md' ? 'my-5 xl:my-10' : 'my-1 xl:my-5';
  const mobileOnlyClassName = mobileOnly ? 'xl:hidden' : '';
  const widthClassName = width === 'lg' ? 'w-full' : width === 'md' ? 'w-3/4' : 'w-1/2';
  const variantClassName = variant === 'light' ? 'border-white opacity-20' : 'border-black opacity-10';

  return (
    <VisibleLoading delay={300}>
      {({ ref, className }) => (
        <div ref={ref} className={className}>
          <hr
            className={`border-top mx-auto ${variantClassName} ${spaceClassName} ${mobileOnlyClassName} ${widthClassName}`.trim()}
          />
        </div>
      )}
    </VisibleLoading>
  );
};
export default Line;
